module.exports = Vue;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 73
// module chunks = 221